module.exports = __webpack_public_path__ + "img/sertifikat-sibinar.d944fbe2.jpeg";